module.exports = __webpack_public_path__ + "static/media/icon-no-progress.6917c1cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-no-progress.svg
// module id = 1881
// module chunks = 0